(ns assemble.templates-page.table
  (:require ["@mui/material/Grid$default" :as Grid]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridActionsCellItem GridLogicOperator]]
            ["react-dropzone-new" :refer [useDropzone]]
            [assemble.component.delete-template-modal :as delete-template]
            [assemble.component.dropzone :refer [grid-drop-overlay grid-drop-props]]
            [assemble.component.file-tree.db :as file-tree.db]
            [assemble.component.move-modal.db :as move-modal.db]
            [assemble.component.table :as table]
            [assemble.resource.premade-templates]
            [assemble.resource.template :as resource.template]
            [assemble.templates-page.drawer.db :as drawer.db]
            [assemble.templates-page.upload-modal.db :as upload-modal.db]
            [cljs-bean.core :refer [bean]]
            [clojure.string :as str]
            [common.util :as util]
            [common.widgets.data-grid :as dg]
            [common.widgets.status :as status]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn on-row-click [^js o ^js event]
  (when (not (.-ignore event))
    (if (:asset-tree/id (.-row o))
      ;; TODO: Also expand the folder on tree?
      (rf/dispatch [:assemble.page.assets.file-tree/set-current-node (:asset-tree/id (.-row o))])
      (rf/dispatch [:assemble.templates-page/set-current-file {:id (.-id o)}]))))

(defn children->ids [children]
  (map :asset-tree/id children))

(defn template-linked-with-adset? [{:keys [revisions]}]
  (-> (some (comp seq :adsetIds) revisions)
      (boolean)))

(defn- is-passed-audit-state? [state]
  (= "passed" state))

(defn get-actions [^js o]
  (let [row (.-row o)
        id (:id row)
        name (:name row)
        base-url (-> row :latestRevision :baseUrl)
        template-type (-> row :latestRevision :templateType)
        audit-state (-> row :latestRevision :auditState)
        creation-tool (or (-> row :latestRevision :creationTool) "")
        is-archived? (:archived row)
        is-pre-made-template? (:pre-made-template row)
        is-pre-made-templates-advertiser? @(rf/subscribe [:premade-templates/is-premade-templates-advertiser?])]
    (to-array
     (cond
       is-pre-made-template?
       (cond-> []
         (#{"after-effects" "html"} template-type)
         (conj ($ GridActionsCellItem
                  {:onClick (fn [_]
                              (case template-type
                                "after-effects" (rf/dispatch [::drawer.db/download-ae-template base-url name])
                                "html" (rf/dispatch [::drawer.db/download-display-template id creation-tool])))
                   :label "Download template"
                   :showInMenu true})))

       (nil? (:asset-tree/id row))
       (cond-> [($ GridActionsCellItem
                   {:onClick (fn [_] (rf/dispatch [::move-modal.db/open {:item-id id
                                                                         :item-name (:name row)
                                                                         :folder-id (:folderId row)}]))
                    :label "Move to"
                    :showInMenu true
                    :data-testid "moveTo"})
                ($ GridActionsCellItem
                   {:onClick (fn [_] (rf/dispatch [:assemble.templates-page/set-current-file {:id id}]))
                    :label "Rename template"
                    :showInMenu true
                    :data-testid "rename"})
                ($ GridActionsCellItem
                   {:onClick (fn [_]
                               (let [option (-> (select-keys row [:name :id])
                                                (assoc :template-type (get-in row [:latestRevision :templateType])))]
                                 (rf/dispatch [::upload-modal.db/open {:files nil
                                                                       :selected-template option
                                                                       :mode :new-revision}])))
                    :label "Upload new revision"
                    :showInMenu true
                    :data-testid "uploadNewRevision"})
                ($ GridActionsCellItem
                   {:onClick (fn [_]
                               (case template-type
                                 "after-effects" (rf/dispatch [::drawer.db/download-ae-template base-url name])
                                 "html" (rf/dispatch [::drawer.db/download-display-template id creation-tool])))
                    :label "Download template"
                    :showInMenu true})
                ($ GridActionsCellItem
                   {:onClick (fn [_] (rf/dispatch [::resource.template/archive-template
                                                   id (not (:archived row))
                                                   is-pre-made-templates-advertiser?]))
                    :disabled (and is-pre-made-templates-advertiser?
                                   (= template-type "after-effects")
                                   (not (is-passed-audit-state? audit-state)))
                    :label (if is-pre-made-templates-advertiser?
                             (if is-archived?
                               "Make public"
                               "Hide from public")
                             (if is-archived?
                               "Unarchive template"
                               "Archive template"))
                    :showInMenu true
                    :data-testid (if (:archived row)
                                   "unarchive"
                                   "archive")})
                ($ GridActionsCellItem
                   {:onClick (fn [_] (rf/dispatch [::delete-template/open-confirmation-modal id (template-linked-with-adset? row)]))
                    :label "Delete template"
                    :showInMenu true
                    :data-testid "delete"})])

       (not= (:asset-tree/id row) resource.template/pre-made-template-folder-id)
       [($ GridActionsCellItem
           #js {:onClick (fn [_] (rf/dispatch [:assemble.assets-page/set-current-folder row]))
                :label "Rename folder"
                :showInMenu true
                :data-testid "rename"})
        ($ GridActionsCellItem
           #js {:onClick (fn [_]
                           (rf/dispatch [::move-modal.db/open
                                         {:item-id (:asset-tree/id row)
                                          :item-name (:asset-tree/name row)
                                          :folder-id (:asset-tree/parent-id row)
                                          :children-ids (children->ids (:children row))
                                          :move-folder? true}]))
                :label "Move folder"
                :showInMenu true})]

       :else []))))

(defn get-row [value-fn _value row ^js _column ^js _apiRef]
  (value-fn row))

(defn render-icon-cell [^js o]
  (when (:asset-tree/id (.-row o))
    ($ Icon
       {:sx #js {:color "grey.40"
                 :fontSize "3rem"}}
       "folder_open")))

(defn render-dimensions-cell [^js o]
  (let [{:keys [width height]} (get (.-row o) :latestRevision)]
    (if-not (or (str/blank? width) (str/blank? height))
      (str width "x" height)
      "")))

(defn render-type-cell [^js o]
  (let [type (.-value o)
        mapping {"html" ["tv" "Display"]
                 "after-effects" ["ondemand_video" "Video"]}
        [icon-name text] (get mapping type)]
    ($ Stack {:direction "row" :gap 1 :alignItems "center"}
       ($ Icon {:sx #js {:color "grey.50"}} icon-name)
       ($ Typography {:variant "button"} text))))

(defn render-premade-template-visibility-cell [^js o]
  (when-not (:asset-tree/id (.-row o))
    (let [is-archived? (.-value o)
          row (.-row o)
          state (-> row :latestRevision :auditState)
          template-type (-> row :latestRevision :templateType)
          public ["success.main" "public"]
          hidden ["grey.40" "hidden"]
          [color text] (cond
                         is-archived? hidden
                         (= "html" template-type) public
                         (is-passed-audit-state? state) public
                         :else hidden)]
      ($ status/simple {:color color :status text}))))

(defn render-status-state-cell [^js o]
  (when-not (:asset-tree/id (.-row o))
    (let [value (.-value o)
          color (case value
                  "archived" "grey.40"
                  "active" "success.main"
                  "audit ongoing" "warning.main"
                  "ready for activation" "info.main"
                  "audit failed" "error.main")]
      ($ status/simple {:color color :status value}))))

(defn- last-modified-cell-comparator [v1 v2 ^js col1]
  (let [sort-dir (.-sort (first (.. col1 -api -state -sorting -sortModel)))]
    (cond (nil? v2) false
          (= sort-dir "asc") (< v1 v2)
          :else (> v1 v2))))

(defn render-last-modified-cell [^js o]
  (when-let [timestamp (.-value o)]
    (util/format-timestamp timestamp)))

(defn- assign-status-for-premade-template
  "For AE premade template we have audit, so we can access state.
   Display templates don't have audit so, and we set them for ready to activation directly."
  [state-mapping state ready-for-activation]
  (or (get state-mapping state) ready-for-activation))

(defn- get-status-state-cell-value [row]
  (let [latest-revision (:latestRevision row)
        state (:auditState latest-revision)
        archived (:archived row)
        is-premade-template? (:premade-template row)
        ready-for-activation "ready for activation"
        audit-failed "audit failed"
        state-mapping {"in progress" "audit ongoing"
                       "passed" ready-for-activation
                       "failed" audit-failed
                       "errors" audit-failed}
        value (cond
                (and archived is-premade-template?) (assign-status-for-premade-template state-mapping state ready-for-activation)
                archived "archived"
                (template-linked-with-adset? row) "active"
                state (get state-mapping state)
                ;; The display template is uploaded and is directly usable for activation (Display templates don’t have an audit process, yet)
                ;; Some 2% of video templates don't have a status. Statuses were introduced after some time. Treat as implicitly set status to passed.
                :else ready-for-activation)]
    value))

(defn- get-name-cell-value [row]
  (or (:name row)
      (:asset-tree/name row)))

(def columns
  #js [#js {:field "icon"
            :headerName ""
            :width 64
            :renderCell render-icon-cell
            :sortable false
            :filterable false}
       #js {:field "name"
            :headerName "Name"
            :minWidth 200
            :flex 1
            :valueGetter (partial get-row get-name-cell-value)}
       #js {:field "type"
            :headerName "Type"
            :width 105
            :valueGetter (partial get-row (comp :templateType :latestRevision))
            :renderCell render-type-cell}
       #js {:field "dimensions"
            :headerName "Dimensions"
            :width 100
            :valueGetter (partial get-row (fn [{{:keys [width]} :latestRevision}] width))
            :renderCell render-dimensions-cell}
       #js {:field "revision"
            :headerName "Revision"
            :width 70
            :valueGetter (partial get-row (comp :version :latestRevision))}
       #js {:field       "status"
            :headerName  "Status"
            :width       210
            :valueGetter (partial get-row get-status-state-cell-value)
            :renderCell  render-status-state-cell}
       #js {:field "lastModified"
            :headerName "Last modified"
            :width 140
            :sortComparator last-modified-cell-comparator
            :valueGetter (partial get-row :updatedAt)
            :renderCell render-last-modified-cell}
       #js {:field "actions"
            :type "actions"
            :column-type "actions"
            :width 16
            :getActions get-actions}])

(defn make-columns [options]
  (if (:premade-templates? options)
    (let [visibility-column (clj->js {:field       "visibility"
                                      :headerName  "Visibility"
                                      :width       85
                                      :valueGetter (partial get-row :archived)
                                      :renderCell  render-premade-template-visibility-cell})
          actions-column (last columns)
          first-columns (vec (butlast columns))]
      (clj->js (conj first-columns visibility-column actions-column)))
    columns))

(def Toolbar
  (uix/as-react
   (fn [{:keys [quick-filter-props]}]
     ($ dg/grid-toolbar
        {:quick-filter-props quick-filter-props
         :sx #js {:justifyContent "flex-start"
                  :px 2}}
        ($ dg/quick-select-filter
           {:label "Type"
            :field "type"
            :id "type"
            :data-testid "typeFilterSelect"
            :filter-options [{:value "html"
                              :label "Display"}
                             {:value "after-effects"
                              :label "Video"}]})
        ($ dg/quick-select-filter
           {:label "Status"
            :field "status"
            :id "status"
            :data-testid "statusFilterSelect"
            :filter-options [{:value "audit failed"
                              :label "Audit failed"}
                             {:value "audit ongoing"
                              :label "Audit ongoing"}
                             {:value "ready for activation"
                              :label "Ready for activation"}
                             {:value "active"
                              :label "Active"}
                             {:value "archived"
                              :label "archived"}]})))))

(defui templates-table []
  (let [current-node-id (use-subscribe [:assemble.page.assets.file-tree/current-node-id])
        is-premade-templates-advertiser? (use-subscribe [:premade-templates/is-premade-templates-advertiser?])
        templates (vals (use-subscribe [::resource.template/templates-by-node current-node-id]))
        template-parent-id (->> (use-subscribe [:assemble.page.assets.file-tree/parent-nodes])
                                (filter #(= (:asset-tree/folder-type %) "templates"))
                                first
                                :asset-tree/id)
        templates-state (use-subscribe [::resource.template/templates-state current-node-id])
        node-children (use-subscribe [::file-tree.db/current-node-children])
        node-children* (if (and (= current-node-id template-parent-id) (not is-premade-templates-advertiser?))
                         (concat [{:asset-tree/id resource.template/pre-made-template-folder-id, :asset-tree/name "Pre-made templates", :asset-tree/slug "Pre-made templates", :asset-tree/parent-id current-node-id, :asset-tree/folder-type "user"}] node-children)
                         node-children)
        value* (into (vec node-children*) templates)
        value (if is-premade-templates-advertiser?
                (map #(assoc % :premade-template true) value*)
                value*)
        tree (use-subscribe [:cqrs/get :asset/list-assets])
        dropzone (useDropzone #js {:onDrop #(rf/dispatch [::upload-modal.db/open {:files %}])
                                   :noClick true
                                   :multiple false
                                   :noKeyboard true})
        drop-active (.-isDragActive dropzone)
        allow-dropping-templates? (use-subscribe [::resource.template/disable-feature-for-pre-made-templates?])]
    ($ :<>
       ($ delete-template/confirmation-modal)
       ($ Grid
          (cond-> {:flex "1 1 0%"
                   :container true
                   :sx #js {:position "relative"
                            :minWidth "40%"}}
            allow-dropping-templates? (merge (grid-drop-props dropzone)))
          ($ :input (bean (.getInputProps dropzone)))
          ($ table/NoRowsContextProvider
             {:value {:asset-type :templates
                      :drop-active drop-active
                      :on-open (.-open dropzone)}}
             ($ DataGridPremium
                {:data-testid "templatesTable"
                 :columns (make-columns {:premade-templates? is-premade-templates-advertiser?})
                 :rows (to-array (or value []))
                 :getRowId (fn [row]
                             ;; Prefix folder- to prevent key collisions
                             (if (:id row)
                               (str (:id row))
                               (str "folder-" (:asset-tree/id row))))
                 :loading (or (:pending tree) (= :pending templates-state))
                 :disableRowSelectionOnClick true
                 :onRowClick on-row-click
                 ;; x-data-grid v6.10.1+ uses Eval to create filter fns,
                 ;; that does seem to conflict with shadow-cljs build?
                 ;; :disableEval true
                 :initialState #js {:sorting #js {:sortModel #js [#js {:field "lastModified"
                                                                       :sort "desc"}]}
                                    :filter #js {:filterModel #js {:items #js [#js {:id "status"
                                                                                    :field "status"
                                                                                    :operator "isAnyOf"
                                                                                    :value (clj->js (cond->
                                                                                                      ["active" "audit failed" "audit ongoing" "ready for activation"]
                                                                                                      is-premade-templates-advertiser? (conj "archived")))}]
                                                                   :logicOperator (.-And GridLogicOperator)}}}
                 :slots #js {:toolbar Toolbar
                             :cell table/CellSlot
                             ;; FIXME: bad inline :slots fn
                             :row (partial table/RowSlot (partial table/get-asset-name-for-test-id :template))
                             :moreActionsIcon table/MoreActionIconSlot
                             :noRowsOverlay table/NoRowsOverlaySlot}
                 :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                                 :toolbar #js {:quick-filter-props {:inputProps #js {:data-testid "searchInput"}}}
                                 :basePopper #js {:data-testid "moreButtonMenu"}
                                 :loadingOverlay #js {:data-testid "progressBar"}
                                 :noResultsOverlay #js {:data-testid "tableMessage"}}
                 :localeText #js {:toolbarQuickFilterPlaceholder "Search in folder..."}
                 :disableColumnSelector true
                 :disableDensitySelector true}))
          (when (and drop-active
                     (seq value))
            ($ grid-drop-overlay {:asset-type :templates}))))))
